module.exports = __webpack_public_path__ + "img/1.323b9c84.jpg";